import PATH from '../paths';

const name = 'Invictus AMG';
const key = 'invictusamg';
const imgUrl = `${ PATH.CDN }/whitelabels/${ key }`;
const images = {
  favicon: `${ imgUrl }/favicon.png`,
  logo: `${ imgUrl }/logo.png`,
  logoSidebar: `${ imgUrl }/logo-sidebar.png`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/background.jpeg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
  
  /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */ 

    --color-amg-blue:                 #3f4b6b;
    --color-amg-lightblue:            #387ec0;

    --color-primary:                  var(--color-amg-blue);
    --color-secondary:                var(--color-amg-lightblue);
    --color-accent:                   var(--color-white);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-link:                     var(--color-amg-blue);
    --color-link-hover:               var(--color-amg-lightblue);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              var(--color-white);
    --anonymous-copy-bg:              var(--color-white);
    --anonymous-heading-color:        var(--color-amg-blue);
    --anonymous-subheading-color:     var(--color-amg-blue);
    --anonymous-text-color            var(--color-amg-blue);
    --anonymous-logo-height:          75px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-amg-blue);
    --sidebar-logo-bg-color: var(--color-white);
    --sidebar-logo-height: 45px;
    --sidebar-label-color: rgba(var(--color-white-rgb), 0.7);
    --sidebar-border-color: var(--color-white);

    --sidebar-button-color: var(--color-white);
    --sidebar-button-color-active: var(--color-white);
    --sidebar-button-color-hover: var(--color-white);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-amg-lightblue);
    --sidebar-button-bg-color-hover: var(--color-amg-lightblue);
    --sidebar-button-border-color: var(--color-white);
    --sidebar-button-border-color-active: var(--color-white);
    --sidebar-button-border-color-hover: var(--color-amg-lightblue);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-amg-blue);
    --btn-primary--border:            var(--color-amg-blue);
    --btn-primary--color:             var(--color-white);
    --btn-primary--colorH:            var(--color-white);
    --btn-primary--bgH:               var(--color-amg-lightblue);
    --btn-primary--borderH:           var(--color-amg-lightblue);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-amg-blue);
    --btn-secondary--color:           var(--color-amg-blue);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-dark);
    --btn-secondary--colorH:          var(--color-dark);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  
  `
  
}; 